<template>
    <div class="flex flex-1 gap-x-4 px-4 mb-4">
        <jet-nav-link
            :href="route('settings.holidays.index')"
            :active="route().current('settings.holidays.index')"
            :class="{ 'active': route().current('settings.holidays.index') || route().current('settings') }"
            class="text-base subnav"
        >Holidays</jet-nav-link>

        <jet-nav-link
            :href="route('settings.general.index')"
            :active="route().current('settings.general.index')"
            :class="{ 'active': route().current('settings.general.index') }"
            class="text-base subnav"
        >General</jet-nav-link>

        <jet-nav-link
            :href="route('settings.users.index')"
            :active="route().current('settings.users.index')"
            :class="{ 'active': route().current('settings.users.index') }"
            class="text-base subnav"
        >Users</jet-nav-link>

        <jet-nav-link
            :href="route('settings.pickers.index')"
            :active="route().current('settings.pickers.index')"
            :class="{ 'active': route().current('settings.pickers.index') }"
            class="text-base subnav"
        >Pickers</jet-nav-link>

        <jet-nav-link
            :href="route('settings.checkers.index')"
            :active="route().current('settings.checkers.index')"
            :class="{ 'active': route().current('settings.checkers.index') }"
            class="text-base subnav"
        >Checkers</jet-nav-link>

        <jet-nav-link
            :href="route('settings.purchasers.index')"
            :active="route().current('settings.purchasers.index')"
            :class="{ 'active': route().current('settings.purchasers.index') }"
            class="text-base subnav"
        >Purchasers</jet-nav-link>

        <jet-nav-link
            :href="route('settings.loaders.index')"
            :active="route().current('settings.loaders.index')"
            :class="{ 'active': route().current('settings.loaders.index') }"
            class="text-base subnav"
        >Loaders</jet-nav-link>

        <jet-nav-link
            :href="route('settings.promo_codes.index')"
            :active="route().current('settings.promo_codes.index')"
            :class="{ 'active': route().current('settings.promo_codes.index') }"
            class="text-base subnav"
        >Promo Codes</jet-nav-link>

        <jet-nav-link
            :href="route('settings.fundraising_codes.index')"
            :active="route().current('settings.fundraising_codes.index')"
            :class="{ 'active': route().current('settings.fundraising_codes.index') }"
            class="text-base subnav"
        >Fundraising Codes</jet-nav-link>

        <jet-nav-link
            :href="route('settings.message_board.index')"
            :active="route().current('settings.message_board.index')"
            :class="{ 'active': route().current('settings.message_board.index') }"
            class="text-base subnav"
        >Message Board</jet-nav-link>

        <jet-nav-link
            :href="route('settings.delivery_zones.index')"
            :active="route().current('settings.delivery_zones.index')"
            :class="{ 'active': route().current('settings.delivery_zones.index') }"
            class="text-base subnav"
        >Delivery Zones</jet-nav-link>

        <jet-nav-link
            :href="route('settings.delivery_times')"
            :active="route().current('settings.delivery_times')"
            :class="{ 'active': route().current('settings.delivery_times') }"
            class="text-base subnav"
        >Delivery Times</jet-nav-link>

        <jet-nav-link
            :href="route('settings.customer_flags.index')"
            :active="route().current('settings.customer_flags.index')"
            :class="{ 'active': route().current('settings.customer_flags.index') }"
            class="text-base subnav"
        >Customer Flags</jet-nav-link>

        <jet-nav-link
            :href="route('settings.location.index')"
            :active="route().current('settings.location.index')"
            :class="{ 'active': route().current('settings.location.index') }"
            class="text-base subnav"
        >Locations</jet-nav-link>

        <jet-nav-link
            :href="route('settings.limit.index')"
            :active="route().current('settings.limit.index')"
            :class="{ 'active': route().current('settings.limit.index') }"
            class="text-base subnav"
        >Order Limits</jet-nav-link>

        <jet-nav-link
            :href="route('settings.auth_codes.index')"
            :active="route().current('settings.auth_codes.index')"
            :class="{ 'active': route().current('settings.auth_codes.index') }"
            class="text-base subnav"
        >Auth Codes</jet-nav-link>

        <jet-nav-link
            :href="route('settings.flyers.index')"
            :active="route().current('settings.flyers.index')"
            :class="{ 'active': route().current('settings.flyers.index') }"
            class="text-base subnav"
        >Flyers</jet-nav-link>
    </div>
</template>

<script>
import JetNavLink from '@/Jetstream/NavLink';

export default {
    components: {
        JetNavLink,
    },

    props: ['customer'],
}
</script>

<style scoped>
.subnav {
    @apply border-white border-b-2 hover:border-red-dark font-semibold;
}
.subnav.active {
    @apply border-b-2 border-red-dark font-bold;
}
</style>
